import gql from "graphql-tag";

export const STAFF_MEMBERS = gql`query ($textSearch: String $roleId: ID $first: Int! $after: String) {
    staffMembers(textSearch: $textSearch roleId: $roleId first: $first after: $after) {
        nodes {
            id
            name
            email
            phone
            role {
                id
                name
            }
            isBanned
            isDeleted
        }
        pageInfo {
            endCursor
            hasNextPage
        }
    }
}`;

export const STAFF_MEMBER = gql`query ($id: ID!) {
    staffMember(id: $id) {
        id
        isSuperAdmin
        name
        email
        phone
        taxNumber
        note
        birthDate
        username
        isBanned
        roleId
        isDeleted
    }
}`;

export const CREATE_STAFF_MEMBER = gql`mutation ($input: StaffMemberInput!) {
    createStaffMember(
        input: $input
    ) {
        id
        isSuperAdmin
        name
        email
        phone
        taxNumber
        note
        birthDate
        username
        isBanned
        roleId
        role {
            id
            name
        }
        isDeleted
    }
}`;

export const UPDATE_STAFF_MEMBER = gql`mutation ($id: ID! $input: StaffMemberInput!) {
    updateStaffMember(
        id: $id
        input: $input
    ) {
        id
        name
        email
        phone
        taxNumber
        note
        birthDate
        username
        roleId
        role {
            id
            name
        }
    }
}`;

export const BAN_STAFF_MEMBER = gql`mutation ($id: ID!) {
    banStaffMember(
        id: $id
    ) {
        id
        isBanned
    }
}`;

export const REVOKE_BAN_STAFF_MEMBER = gql`mutation ($id: ID!) {
    revokeBanStaffMember(
        id: $id
    ) {
        id
        isBanned
    }
}`;

export const DELETE_STAFF_MEMBER = gql`mutation ($id: ID!) {
    deleteStaffMember(
        id: $id
    ) {
        id
        isDeleted
    }
}`;
